import {get} from 'lodash';

export default (state = {}, {clientId, orders, meta, appendData}: any) => {
  const prevMeta = get(state, `allOrdersMeta.${clientId}`, {});
  const sortBy = get(meta, 'sortParams.sortBy');
  const sortOrder = get(meta, 'sortParams.sortOrder');
  const hasSortParams = Boolean(sortBy || sortOrder);
  const isDefaultOrdersSort =
    (sortBy || 'orderDate') === 'orderDate' && (sortOrder || 'DESC') === 'DESC';
  const shouldUpdateProfileOrders =
    hasSortParams && isDefaultOrdersSort && !appendData;
  const hasProfileOrdersInState =
    typeof get(prevMeta, 'profileOrders') !== 'undefined';

  return {
    ...state,
    allOrders: {
      ...get(state, 'allOrders', {}),
      [clientId]: appendData
        ? [...get(state, `allOrders.${clientId}`, []), ...orders]
        : orders,
    },
    allOrdersMeta: {
      ...get(state, 'allOrdersMeta', {}),
      [clientId]: {
        ...prevMeta,
        ...meta,
        ...(shouldUpdateProfileOrders || hasProfileOrdersInState
          ? {
              profileOrders: shouldUpdateProfileOrders
                ? orders
                : get(prevMeta, 'profileOrders', []),
            }
          : {}),
        page: {
          ...prevMeta?.page,
          ...meta?.page,
        },
      },
    },
  };
};
